import {Hybird, HybirdProvide, pushHybird} from "@hybird/core/hybird";
import {createFlutterBluetoothDevice} from "@hybird/flutter/device/flutterBluetoothDevice";
import {BleDeviceConnectProvide} from "@hybird/device/protocol/ble";
import {Device, deviceConnectProvides, networkConnectProvide, networkDeviceConnectProvides,} from "@hybird/device";
import axiosInstall from "@hybird/flutter/axios/axios";
import service from "@hybird/core/request";
import flutterAdapters from "@hybird/flutter/axios/flutterRequest";
import {setGeolocation} from "@hybird/device/interceptor/beginSeal/amapBeginSeal";
import {SerialDeviceConnectProvide} from "@hybird/device/protocol/serial";
import {createFlutterSerialDevice} from "@hybird/flutter/device/flutterSerialDevice";
import {flutterCore} from "@hybird/flutter/bridge/core";
import {flutterCamera} from "@hybird/flutter/bridge/camera";
import {flutterDeviceStorage} from "@hybird/flutter/bridge/deviceStorage";
import {flutterConsole} from "@hybird/flutter/bridge/console";
import {FlutterTest} from "@hybird/flutter/bridge/test";
import {flutterFileIsolate} from "@hybird/flutter/bridge/fileIsolate";
import {flutterWX} from "@hybird/flutter/bridge/wx";
import {flutterLocation} from "@hybird/flutter/bridge/location";
import {flutterWIFI} from "@hybird/flutter/bridge/wifi";
import {flutterNetworkManage} from "@hybird/flutter/bridge/network";
import {FlutterXda} from "@hybird/flutter/bridge/xda";
import {flutterVersionManager} from "@hybird/flutter/bridge/version";
import {flutterBluetooth} from "@hybird/flutter/bridge/blutooth";
import {flutterRequest} from "@hybird/flutter/bridge/request";
import {FlutterPreview} from "@hybird/flutter/bridge/preview";
import {flutterUsbDevice} from "@hybird/flutter/bridge/usbDevice";
import {setBridge} from "@hybird/core/bridge/hybirdBridge";
import {
  ForegroundTaskServiceDeviceProtocolDeviceMethodInterceptor,
} from "@hybird/flutter/device/foregroundTaskServiceBeginSeal";
import {flutterMqtt} from "@hybird/flutter/bridge/mqtt";
import {FlutterMqttDeviceConnectProvide} from "@hybird/flutter/device/flutterMqtt";
import {flutterInfrared} from "@hybird/flutter/bridge/infrared";
import {flutterPdf} from "@hybird/flutter/bridge/flutterPdf";
import {flutterFingerprint} from "@hybird/flutter/bridge/fingerprint";
import {FlutterAdb} from "@hybird/flutter/bridge/xdaAdb";
import {YkySystem} from "@hybird/flutter/bridge/ykySystem";
import {flutterBridge, getBridge, xda, isSupport, ohosBridge} from '@hybird/flutter/bridge'
import {FlutterEpsonScanner} from "@hybird/flutter/bridge/epsonScanner";
import {flutterBluetoothPeripheral} from "@hybird/flutter/bridge/device/bluetoothPeripheral";
import {flutterVi5300} from "@hybird/flutter/bridge/device/vi5300";
import {flutterSensors} from "@hybird/flutter/bridge/device/sensors";
import {flutterGpio} from "@hybird/flutter/bridge/device/gpio";
import {flutterSteppingMotor} from "@hybird/flutter/bridge/device/steppingMotor";

class HybirdFlutter extends Hybird {
  constructor() {
    super();

    xda.ready(() => {
      xda.onConnectivityChange(() => {
        //TODO 需要补充判断
        window.dispatchEvent(new Event("offline"));
        window.dispatchEvent(new Event("online"));
      });

      xda.onHistoryBack((params) => {
        return false;
      });
    });
  }
}

const fns = [];

const startFlutter = () => {
  fns.push(
          new YkySystem(),
          new FlutterAdb(),
          flutterCore,
          flutterCamera,
          flutterDeviceStorage,
          flutterConsole,
          new FlutterTest(),
          flutterFileIsolate,
          flutterWX,
          flutterLocation,
          flutterWIFI,
          flutterNetworkManage,
          new FlutterXda(),
          flutterVersionManager,
          flutterBluetooth,
          flutterRequest,
          new FlutterPreview(),
          flutterUsbDevice,
          flutterMqtt,
          flutterInfrared,
          flutterPdf,
          flutterFingerprint,
          flutterBluetoothPeripheral,
          flutterVi5300,
          flutterSensors,
          flutterGpio,
          flutterSteppingMotor,
          new FlutterEpsonScanner()
  );

  const bridge = getBridge();

  window.flutter_xda = {
    on: bridge.flutterOn.bind(bridge),
  };

  setBridge(bridge).then(() => {
    fns
            .filter((v) => v["init"])
            .forEach((v) => {
              v["init"].call(v, xda);
            });
  });

  //flutter ble
  deviceConnectProvides.splice(
          0,
          0,
          new BleDeviceConnectProvide(createFlutterBluetoothDevice, networkConnectProvide)
  );
  deviceConnectProvides.splice(
          0,
          0,
          new SerialDeviceConnectProvide(createFlutterSerialDevice, networkConnectProvide)
  );
  // Device.interceptors.push(ForegroundTaskServiceDeviceProtocolDeviceMethodInterceptor);
  // Device.interceptors.push(ForegroundTaskServiceBeginSealInterceptor);
  // Device.interceptors.push(ForegroundTaskServiceOperationDeviceMethodInterceptor);

  if (!ohosBridge.isSupport()) {
    const flutterMqttDeviceConnectProvide = new FlutterMqttDeviceConnectProvide();
    deviceConnectProvides.splice(0, 0, flutterMqttDeviceConnectProvide);
    networkDeviceConnectProvides.splice(0, 0, flutterMqttDeviceConnectProvide);
  }

  if (!process.env.jest) {
    import("@hybird/device/components/device").then(({switchCamera}) => {
      switchCamera().finally();
    });
  }

  // 响应拦截器
  service.interceptors.request.use(async (request) => {
    if (request.headers["Content-Type"] === "multipart/form-data") {
      if (request.data instanceof FormData) {
        request.data.forEach((value, key) => {
          if (typeof value === "string" && value.startsWith("file://")) {
            request.adapter = flutterAdapters;
          }
        });
      } else {
        for (const key in request.data) {
          const value = request.data[key];

          if (typeof value === "string" && value.startsWith("file://")) {
            request.adapter = flutterAdapters;
          }
        }
      }
    }

    return request;
  });

  setGeolocation(() => {
    return xda.getLocation().then((data) => {
      //{"callbackTime":"2025-03-25 17:13:01","locationTime":"2025-03-25 17:13:02","locationType":5,"latitude":30.18517,"longitude":120.200907,"accuracy":30,"altitude":0,"bearing":0,"speed":0,"country":"中国","province":"浙江省","city":"杭州市","district":"滨江区","street":"江二路","streetNumber":"459号","cityCode":"0571","adCode":"330108","address":"浙江省杭州市滨江区江二路459号靠近英飞特科技园","description":"在英飞特科技园附近"}
      return {
        address: data.address,
        lon: data.longitude,
        lat: data.latitude,
        province: data?.province,
        city: data?.city,
        township: data?.township,
        street: data?.street,
        district: data?.district,
      };
    });
  });

  pushHybird(new HybirdProvide(HybirdFlutter, isSupport, -50));
  const oldSetInterval = window.setInterval;
  const oldClearInterval = window.clearInterval;
  window.setInterval = (handler, timers, flutter) => {
    if (flutter) {
      return xda.setInterval(handler, timers);
    } else {
      return oldSetInterval(handler, timers);
    }
  };
  window.clearInterval = (id, flutter) => {
    if (flutter) {
      return xda.clearInterval(id);
    } else {
      return oldClearInterval(id);
    }
  };
};

axiosInstall();

console.log("flutter", isSupport());

if (isSupport()) {
  startFlutter();
} else {
  xda.ready(() => {
    console.log("flutter ready", isSupport());
    startFlutter();
  });
}

export {xda, isSupport};
